import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

class Loading extends React.Component {

	render () {
		return ( 
			this.props.loading == true && this.props.location == this.props.state_location &&
			<div className="loader">
				<img src="/img/spinner.png" className="spinner anim-spin mb-0"/>
			</div>
		 );
	}
}

function mapStateToProps(state) {
	return { loading:state.loading, state_location: state.loading_location }
}

export default connect(mapStateToProps)(Loading);